export default {
  title: 'Punten sparen & beloningen ontvangen',
  header: {
    pickup: 'Afhalen in 5 minuten',
  },
  recommendations: {
    title: 'Aanbevolen',
  },
  discounts: {
    title: 'Kortingen',
    data: [
      {
        title: '+125 extra punten',
        description: 'Beoordeel ons op Google',
      },
      {
        title: '+{{amount}} korting',
        description: '+{{amount}} korting wanneer u betaalt met de code {{code}}',
      },
    ],
    button: {
      add: '+ Toevoegen',
    },
  },
  rewards: {
    title: 'Beloningen & coupons',
    balance: 'Saldo',
    points: 'Punten',
  },
};
